import React from 'react'
import styled from 'styled-components'
import { find } from 'lodash'

import { theme } from '../../constants/theme'
import { tagsColor, tagsCommentColor } from '../../constants/status'

import { Tag } from './Tag'
import { Link } from './Link'
import { Trad } from './Trad'
import { H1 } from './Typography'

export const PageTitle = ({
  title, subTitle, tradId, children, backLink, backLinkTrad, status, history,
}) => (
  <OuterWrapper>
    {backLink && backLinkTrad && (
      <BackLink to={backLink} data-html2canvas-ignore="true">
        {'< '}
        <Trad id={backLinkTrad} />
      </BackLink>
    )}

    <Wrapper>
      <Header>
        {title ? <Title bold block>{title}</Title>
          : <Title tradId={tradId} bold block />}
        {subTitle && (
          <div>{subTitle}</div>
        )}
      </Header>
      <div>
        {children}
      </div>
    </Wrapper>
    <TagsWrapper>
      {status && (
        <Tag label={`facmStatus.${status}`} color={tagsColor[status]} filled />
      )}
      {status && find(history, ((elem) => elem.comment && status !== 'ALERT')) && (
        <Tag label="comments" color={tagsCommentColor[status]} />
      )}
      {status === 'ALERT' && (
        <Tag label="facmStatus.DONE" color={tagsColor.DONE} filled />
      )}
    </TagsWrapper>
  </OuterWrapper>
)

const OuterWrapper = styled.div`
  padding: 72px 46px 30px 46px;
  @media (max-width: 1000px) {
    padding-left: 15px;
  }
`

const BackLink = styled(Link)`
  padding-bottom: 12px;
  display: inline-block;
  text-decoration: underline;
  color: ${theme.colors.textGray};
`

const Title = styled(H1)`
  display: block;
  color: ${theme.colors.black};
  font-size: 28px;
  margin-bottom: 10px;
`
const Header = styled.div`
  display: flex;
  flex-direction: column;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
const TagsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`
